import { EntityIcon } from '@components/core-ui/EntityIcon/';
import { AdminUserDetailsResultDto } from 'app/API';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  user: AdminUserDetailsResultDto;
};

export const Teams = ({ user }: TProps) => {
  if (!user) {
    return null;
  }

  const renderTeam = (team: AdminUserDetailsResultDto['teams'][0]) => {
    const org = (user.orgRelations ?? []).find((organization) => organization.id === team.organizationId);
    return (
      <div className="team" key={team.id}>
        <EntityIcon
          name={team.name || team.slug}
          backgroundColor="var(--color-surface-muted)"
          color="var(--color-text)"
          className="team-shortName"
        />
        <div className="team-right">
          <div className="team-name">{team.name}</div>
          {!!org && <div className="team-org">{org.name}</div>}
        </div>
      </div>
    );
  };

  return (
    <Wrapper>
      <LeftSide>
        <h3>Teams</h3>
      </LeftSide>

      <RightSide>{(user.teams ?? []).map((team) => renderTeam(team))}</RightSide>
    </Wrapper>
  );
};
